import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import api from "../lib/api";
import { ChevronRight } from "lucide-react";
import { PageContainer, PageHeader, Card, EmptyState, Loading, Button, Pill } from "../components/kit";

function CheatBadge({ count }) {
  if (count === 0) return <Pill tone="green">✓ Clean</Pill>;
  if (count <= 2) return <Pill tone="amber" className="text-yellow-600" >⚠ {count}</Pill>;
  return <Pill tone="red">✗ {count}</Pill>;
}

export default function JobCandidates() {
  const { id } = useParams();
  const [data, setData] = useState(null);

  useEffect(() => { api.get(`/jobs/${id}/candidates`).then(({ data }) => setData(data)); }, [id]);

  if (!data) return <Loading label="Loading shortlist…" />;

  return (
    <PageContainer>
      <PageHeader eyebrow="Shortlist" title={data.job.title} subtitle={data.job.description} />

      {data.candidates.length === 0 ? (
        <EmptyState
          title="No interviews completed for this role yet."
          action={<Button to="/dashboard" variant="secondary">Back to dashboard</Button>}
        />
      ) : (
        <Card padding="p-0" className="overflow-hidden">
          <div className="grid grid-cols-12 bg-secondary/40 border-b border-border font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground">
            <div className="col-span-3 p-3">Candidate</div>
            <div className="col-span-2 p-3">JD Match</div>
            <div className="col-span-1 p-3">HR</div>
            <div className="col-span-1 p-3">Tech</div>
            <div className="col-span-1 p-3">Behav.</div>
            <div className="col-span-1 p-3">Cheats</div>
            <div className="col-span-2 p-3">Rec.</div>
            <div className="col-span-1 p-3" />
          </div>
          <div className="divide-y divide-border">
            {data.candidates.map((c) => (
              <div key={c.interview_id} className="grid grid-cols-12 items-center hover:bg-secondary/30 transition-colors">
                <div className="col-span-3 p-4">
                  <div className="font-semibold text-[#0F172A]">{c.candidate_name}</div>
                  <div className="text-xs text-muted-foreground">{c.candidate_email}</div>
                </div>
                <div className="col-span-2 p-4 font-display text-2xl font-bold text-[#0F172A]">
                  {c.jd_match_percent ? `${Math.round(c.jd_match_percent)}%` : "—"}
                </div>
                <div className="col-span-1 p-4 font-mono">{Math.round(c.hr_score || 0)}</div>
                <div className="col-span-1 p-4 font-mono">{Math.round(c.technical_score || 0)}</div>
                <div className="col-span-1 p-4 font-mono">{Math.round(c.behavioral_score || 0)}</div>
                <div className="col-span-1 p-4"><CheatBadge count={c.cheat_events} /></div>
                <div className="col-span-2 p-4 text-sm font-semibold text-[#0F172A]">{c.recommendation || "—"}</div>
                <div className="col-span-1 p-4">
                  <Link to={`/interviews/${c.interview_id}/results`}
                    className="inline-flex items-center text-[#0025D8] hover:text-[#001CB3]" data-testid={`view-${c.interview_id}`}>
                    <ChevronRight className="w-5 h-5" />
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </Card>
      )}
    </PageContainer>
  );
}
